<template>
  <v-container>
    <div v-if="jobs.length === 0"> 登録されているジョブがありません。</div>
    <v-row v-else>
      <v-col v-for="(item, i) in items" :key="i" cols="12">
        <v-card>
          <v-card-title>
            {{ item.jobName }}
            <v-spacer />
          </v-card-title>
          <BarChart class="chart" :chartData="arrangeForChart(item)" :options="options" />
          <small style="color:grey"> ※未実施の場合は0になります。 </small>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BarChart from "@/components/BarChart.vue";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  components: {
    BarChart,
  },

  computed: {
    ...mapGetters(["job/myJobs", "job/otherUserJobs", "record/myRecords", "record/otherUserRecords"]),
    jobs() { return this.isLoginuser ? this["job/myJobs"] : this["job/otherUserJobs"]; },
    records() { return this.isLoginuser ? this["record/myRecords"] : this["record/otherUserRecords"]; },
    items() {
      const items = [];
      this.jobs.forEach((userJob) => {
        const records = [];
        this.records.forEach((userRecord) => {
          if (userJob.jobId === userRecord.jobId) {
            records.push(userRecord);
          }
        });
        userJob.records = records;
        items.push(userJob);
      });
      return items;
    },
    arrangeForChart() {
      return function(item) {
        const dates = [];
        item.records.forEach((record) => {
          dates.push(moment.unix(record.recordAt).format("MM/DD"));
        });
        const sortedDates = dates.sort();

        const valueList = [];
        item.records.forEach((record) => {
          valueList.push(record.recordEvaluation);
        });

        const jobForChart = {
          label: item.jobName,
          data: valueList,
          backgroundColor: "rgba(255, 130, 3, 0.2)",
          borderColor: "#f57c00",
          borderWidth: 1,
        };

        const datasets = [];
        datasets.push(jobForChart);
        const chartData = {
          labels: sortedDates,
          datasets: datasets,
        };
        return chartData;
      };
    },
  },

  data() {
    return {
      options: {
        responsive: true,
        display: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                max: 5,
                stepSize: 1,
              },
            },
          ],
        },
        plugins: {
          colorschemes: {
            scheme: "tableau.Tableau20",
          },
        },
      },
    };
  },

  props: {isLoginuser: Boolean}
};
</script>
